import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Box from 'components/Box';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Text from 'components/Text';
import TextInput from 'components/TextInput';
import { clampToPageRange } from '.';
import { useTranslation } from 'react-i18next';
function JumpToPageWidget(_ref) {
  var pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    getPageLink = _ref.getPageLink,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(currentPage),
    _useState2 = _slicedToArray(_useState, 2),
    targetPage = _useState2[0],
    setTargetPage = _useState2[1];
  var inputRef = useRef(null);
  var history = useHistory();
  function changeTarget(e) {
    setTargetPage(clampToPageRange(e.currentTarget.value, pageCount));
  }
  function submit(e) {
    e.preventDefault();
    history.push(getPageLink(targetPage));
    if (onClose) onClose(e);
  }
  function onEnterKey(e) {
    if (e.key === 'Enter') {
      submit(e);
    }
  }

  // Focus & select input field upon opening this dialog
  useEffect(function () {
    // Set timeout to prevent a jump in scroll position in IE11
    // when the selection is triggered before the tooltip's/widget's
    // final position has been applied
    setTimeout(function () {
      if (inputRef !== null && inputRef !== void 0 && inputRef.current) {
        inputRef.current.select();
      }
    }, 0);
  }, []);
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    borderBottom: "thin",
    px: "s",
    py: "xs"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "label",
    htmlFor: "jumpToPageNumber"
  }, t('pagination_jump_to_page'))), /*#__PURE__*/React.createElement(Flex, {
    px: "s",
    py: "xs"
  }, /*#__PURE__*/React.createElement(Box, {
    shrink: true,
    width: 75
  }, /*#__PURE__*/React.createElement(TextInput, {
    type: "number",
    id: "jumpToPageNumber",
    ref: inputRef,
    value: targetPage.toString(),
    min: "1",
    max: pageCount.toString(),
    onChange: changeTarget,
    onKeyDown: onEnterKey
  })), /*#__PURE__*/React.createElement(Box, {
    ml: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: submit
  }, t('pagination_jump_to_page_submit')))));
}
export default JumpToPageWidget;